
export default function toDateObject(value) {
    if(!value) return null;

    var dTimezone = new Date();
    var offset = dTimezone.getTimezoneOffset() / 60;
    var date = new Date(Date.parse(value));
    date.setHours(date.getHours() + offset);

    return new Date(date);
}